<template>
  <div class="footer">
    <div class="foot-head">
      <div class="foot-left">
        <img src="@/assets/img/logo@2x.png" alt="" />
        <div class="left-cont">
          <div class="box-special">
            <div class="cont-item">
              <!-- <img src="@/assets/img/phone@2x.png" alt="" /> -->
              <span>{{ footer.Tel }}</span>
              <span>86-10-62301618</span>
            </div>
            <div class="cont-item">
              <!-- <img src="@/assets/img/mail@2x.png" alt="" /> -->
              <span>{{ footer.Fax }}</span>
              <span>100191</span>
            </div>
          </div>
          <div class="box-special">
            <div class="cont-item">
              <!-- <img src="@/assets/img/printer@2x.png" alt="" /> -->
              <span>{{ footer.Email }}</span>
              <span>chinabricsaicenter@outlook.com</span>
            </div>
            <div class="cont-item">
              <!-- <img src="@/assets/img/Maps@2x.png" alt="" /> -->
              <span>{{ footer.Add }}</span>
              <span>{{footer.address}}</span>
            </div>
          </div>
          <!-- <div class="cont-item">
            <img src="@/assets/img/mail@2x.png" alt="" />
            <span>100191</span>
          </div> -->
        </div>
      </div>
      <div class="foot-new-right">
        <div class="right-code">
          <img src="@/assets/img/code.jpg" alt="" />
          <div>{{footer.OfficialWeChatAccount}}</div>
        </div>
      </div>
      <div class="foot-right">
        <div class="right-cont">
          <div class="cont-item">
            <div class="item-head" @click="toNew('/Interformation')">{{footer.InformationExchange}}</div>
            <div class="items">
              <div class="item" @click="toNew('/Interformation','section1')">{{footer.InternationalNews}}</div>
              <div class="item" @click="toNew('/Interformation','section2')">{{footer.GlobalTrends}}</div>
            </div>
          </div>
          <div class="cont-item">
            <div class="item-head" @click="toNew('/casedisplay')">{{footer.Industrydocking}}</div>
            <div class="items">
              <div class="item" @click="toNew('/casedisplay')">{{footer.SupplyAndDemandApplication}}</div>
              <div class="item">{{footer.RequirementsLibrary}}</div>
              <div class="item">{{footer.SupplyLibrary}}</div>
            </div>
          </div>
          <div class="cont-item">
            <div class="item-head" @click="toNew('/countryMe')">{{footer.ApplicationEmpowerment}}</div>
            <div class="items">
              <div class="item" @click="toNew('/countryMe')">{{footer.EnterpriseEmpowerment}}</div>
              <div class="item">{{footer.Technologyempowerment}}</div>
            </div>
          </div>
          <div class="cont-item">
            <div class="item-head" @click="toNew('/governance')">{{footer.GovernanceCooperation}}</div>
            <div class="items">
              <div class="item" @click="toNew('/governance','governZcfg')">{{footer.PoliciesAndRegulations}}</div>
              <div class="item" @click="toNew('/governance','governYjbg')">{{footer.ResearchReport}}</div>
              <div class="item" @click="toNew('/governance','governGjzl')">{{footer.InternationalGovernance}}</div>
              <div class="item" @click="toNew('/governance','governGjbz')">{{footer.InternationalStandards}}</div>
            </div>
          </div>
          <div class="cont-item">
            <div class="item-head" @click="toNew('/Centraloutcome')">{{footer.CenterAchievements}}</div>
            <div class="items">
              <div class="item" @click="toNew('/Centraloutcome','zxcg','会议')">{{footer.Meeting}}</div>
              <div class="item" @click="toNew('/Centraloutcome','zxcg','活动')">{{footer.Activity}}</div>
              <div class="item" @click="toNew('/Centraloutcome','zxcg','白皮书')">{{footer.whitepaper}}</div>
              <div class="item" @click="toNew('/Centraloutcome','zxcg','蓝皮书')">{{footer.BlueBook}}</div>
              <div class="item" @click="toNew('/Centraloutcome','zxcg','标准')">{{footer.standard}}</div>
            </div>
          </div>
          <div class="cont-item">
            <div class="item-head" @click="toNew('/Aboutus')">{{footer.aboutUs}}</div>
            <div class="items">
              <div class="item" @click="toNew('/Aboutus','clbj')">{{footer.BackgroundOfEstablishment}}</div>
              <div class="item" @click="toNew('/Aboutus','zzjg')">{{footer.OrganizationalStructure}}</div>
              <div class="item" @click="toNew('/Aboutus','zxfw')">{{footer.CenterServices}}</div>
            </div>
          </div>
        </div>
        <div class="right-code">
          <img src="@/assets/img/code.jpg" alt="" />
          <div>{{footer.OfficialWeChatAccount}}</div>
        </div>
      </div>
    </div>
    <div class="foot-bottom">
      <span class="sp1">{{footer.copyright}}</span>
      <a href="https://beian.miit.gov.cn/" target="_blank" class="sp2">京ICP备09013372号-236</a>
      <a v-if="$i18n.locale === 'zh'" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802045325" target="_blank" class="sp3"><img  src="@/assets/img/beian.png" />京公网安备11010802045325号</a>
      <span v-else class="sp3">京公网安备11010802045325号</span>
      <!-- <a href="https://beian.miit.gov.cn/" target="_blank" class="sp2">{{footer.ICP}}</a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802045325" target="_blank" class="sp3"><img  src="@/assets/img/beian.png" />{{footer.Security}}</a> -->
      <!-- <span class="sp2">京ICP备041221882220号-1</span>
      <span class="sp3">京公网安备111221882220号</span> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed:{
    footer(){
      return this.$t('footer')
    }
  },
  mounted() {},
  methods:{
    toNew(path,ids,isSelect){
      if(ids){
        let parseUrl = {
          isPont:ids,
          isSelect:isSelect?isSelect:''
        }
        this.$bus.$emit('changePont',parseUrl)
        if(isSelect){
          this.$router.push({path:path,query:{isSelect:isSelect}})
        }else{
          this.$router.push({path:path}) 
        }
      }else{
        this.$router.push(path)
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 412px;
  background: #e9e9e9;
  display: flex;
  flex-direction: column;
  .foot-head {
    // flex: 1;
    // padding: 50px 100px 40px 100px;
    // padding: 2% 5% 2% 5%;
    height: 170px;
    // padding: 0 40px;
    max-width: 1200px;
    // width: 1200px;
    width: 100%;
    margin: 0 auto;
    margin-top: 40px;
    padding-bottom: 40px;
    box-sizing: border-box;
    border-bottom: 1px solid #cccccc;
    display: flex;
    justify-content: space-between;
    .foot-left {
      margin-right: 100px;
      display: flex;
      flex-direction: column;
      width: 840px;
      &>img {
        width: 500px;
        // height: 48px;
      }
      .left-cont {
        // flex: 1;
        margin-top: 28px;
        // display: flex;
        // align-items: center;
        .box-special {
          display: flex;
          align-items: center;
          .cont-item:first-child {
            width: 270px;
          }
        }
        .cont-item {
          display: flex;
          align-items: center;
          height: 24px;
          line-height: 24px;
          // margin-bottom: 13px;
          margin-right: 40px;
          img {
            height: 16px;
          }
          span {
            font-size: 14px;
            color: #666666;
            text-align: right;
            margin-left: 5px;
            min-width: 60px;
          }
          span:last-child {
            text-align: left;
          }
        }
        .cont-item:last-child {
          margin-bottom: 0;
        }
      }
    }
    .foot-new-right {
      // flex: 1;
      .right-code {
        // margin-left: 25px;
        img {
          height: 113px;
        }
        > div {
          height: 24px;
          font-size: 14px;
          color: #666666;
          line-height: 24px;
          text-align: center;
        }
      }
    }
    .foot-right {
      display: flex;
      flex: 1;
      display: none;
      .right-cont {
        flex: 1;
        display: flex;
        justify-content: space-between;
        .cont-item {
          width: calc(16.6% - 12px);
          display: flex;
          flex-direction: column;
          text-align: left;
          .item-head {
            cursor: pointer;
            height: 24px;
            font-size: 16px;
            color: #080808;
            line-height: 24px;
          }
          .items {
            margin-top: 20px;
            .item {
              font-size: 14px;
              color: #666666;
              line-height: 24px;
              cursor: pointer;
              margin-bottom: 20px;
            }
            .item:last-of-type{
                margin-bottom: 0px;
            }
          }
        }
      }
      .right-code {
        margin-left: 25px;
        img {
          height: 113px;
        }
        > div {
          height: 24px;
          font-size: 14px;
          color: #666666;
          line-height: 24px;
          text-align: center;
        }
      }
    }
  }
  .foot-bottom {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 12px;
      color: #666666;
      line-height: 12px;
    }
    a {
      font-size: 12px;
      color: #666666;
      line-height: 12px;
      cursor: pointer;
      text-decoration: none;
    }
    .sp2 {
      margin: 0 40px;
    }
    .sp3 {
      display: flex;
      align-items: center;
      img {
        margin-right: 6px;
      }
    }
  }
}
@media (min-width: 600px) and (max-width: 1040px) {
  .foot-head {
    display: none !important;
  }
}
@media (max-width: 600px) {
  .foot-head {
    display: none !important;
  }
}
</style>
